module.exports = __webpack_public_path__ + "static/media/home-lg.78bdb2ff.svg";